import React, { useState } from 'react'
import './Login.css';
import { Link, useHistory } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth'


import shephaTitleLogo from '../../assets/shephaTitleLogo.png'
import backgroundLogin from '../../assets/loginBackground.png'
import ButtonLogin from './ButtonLogin/ButtonLogin';
import Or from './Or/Or';
import InputLogin from './InputLogin/InputLogin';
import IconGoogleColor from '../../assets/icons/IconGoogleColor';
import IconAppleWhite from '../../assets/icons/IconAppleWhite';
import WelcomeForm from './WelcomeForm/WelcomeForm';
import Loading from '../Loading/Loading';

const MAIN = 1;
const LOGIN = 2;
const SIGNUP = 3;




const Login = () => {

    const [state, setState] = useState(MAIN);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [pass, setPass] = useState("");
    const history = useHistory()

    let content = null;
    switch (state) {
        case LOGIN:
            content = <MainForm
                state={LOGIN}
                onClick={() => handleLoginUser()}
                onEmailChange={(email) => setEmail(email)}
                onPassChange={(pass) => setPass(pass)} 
                onGoogleLogin={() => handleGoogleLogin()}/>
            break;
        case SIGNUP:
            content = <MainForm
                state={SIGNUP}
                onClick={() => handleCreateUser()}
                onEmailChange={(email) => setEmail(email)}
                onPassChange={(pass) => setPass(pass)} 
                onGoogleLogin={() => handleGoogleLogin()}/>
            break;
        default:
            content = <WelcomeForm
                onRegisterButtonPress={() => setState(SIGNUP)}
                onLoginButtonPress={() => setState(LOGIN)} />
    }

    const handleAnonymousLogin = () => {
        setLoading(true);
        firebase.auth().signInAnonymously()
            .then(() => {
                setLoading(false)
                history.replace('/course')
            })
            .catch(function (error) {
                setLoading(false)
                // Handle Errors here.
                /* var errorCode = error.code;
                var errorMessage = error.message; */

            });

    }

    const handleCreateUser = () => {
        setLoading(true);
        firebase.auth().createUserWithEmailAndPassword(email, pass)
            .then(() => {
                setLoading(false)
                history.replace('/course')
            })
            .catch((error) => {
                // var errorCode = error.code;
                var errorMessage = error.message;
                alert(errorMessage)
                setLoading(false)
            })
    }

    const handleLoginUser = () => {
        setLoading(true);
        firebase.auth().signInWithEmailAndPassword(email, pass)
            .then(() => {
                setLoading(false)
                history.replace('/course')
            })
            .catch((error) => {
                // var errorCode = error.code;
                var errorMessage = error.message;
                alert(errorMessage)
                setLoading(false)
            })
    }

    const handleGoogleLogin = () => {
        setLoading(true);
        var provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider).then((result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            //var token = result.credential.accessToken;
            // The signed-in user info.
            // var user = result.user;
            // ...
            setLoading(false)
            history.replace('/course')
        }).catch((error) => {
            // Handle Errors here.
            // var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            // ...
            alert(errorMessage)
            setLoading(false)
        });
    }


    if (loading)
        return <Loading />

    return (
        <div className="loginScreen">
            <img className="background" src={backgroundLogin} alt="background" />
            <Link to="/">
                <img
                    className="logo"
                    src={shephaTitleLogo}
                    alt="Shepha"
                />
            </Link>
            <p
                className='anonymousLogin'
                onClick={() => handleAnonymousLogin()}>
                Start Anonymously
            </p>
            {content}
            <p style={{
                marginTop: '48px'
            }}>
                {state === SIGNUP ?
                    'Already have an account? ' :
                    state === LOGIN ?
                        'Don\'t have an account? ' :
                        null}
                <span
                    onClick={() => state === LOGIN ?
                        setState(SIGNUP) :
                        state === SIGNUP ? setState(LOGIN) : {}}
                    style={{
                        color: '#309CFF',
                        cursor: 'pointer'
                    }}>
                    {state === SIGNUP ?
                        'Log in' :
                        state === LOGIN ?
                            'Create now' :
                            null}
                </span>
            </p>
        </div>
    )
}

export default Login


const MainForm = ({
    state,
    onClick,
    onEmailChange,
    onPassChange,
    onGoogleLogin,
}) => {
    return (
        <>
            <div className='socialsContainer'>
                <ButtonLogin
                    style={{
                        backgroundColor: '#F4F4F4',
                        color: '#309CFF',
                        height: '40px',
                        fontSize: '18px',
                        margin: '0 8px 0 0',
                    }}
                    isLeftIcon
                    LeftIcon={IconGoogleColor}
                    title={"Google"}
                    onClick={onGoogleLogin}
                />
                <ButtonLogin
                    style={{
                        backgroundColor: '#1F1F1F',
                        color: '#ffffff',
                        height: '40px',
                        fontSize: '18px',
                        margin: '0 0 0 8px',
                    }}
                    isLeftIcon
                    LeftIcon={IconAppleWhite}
                    title={"Apple"}
                />
            </div>
            <Or />
            <InputLogin
                style={{ marginTop: '8px' }}
                title='Email'
                type='email'
                onChange={(value) => onEmailChange(value)}
                maxLength={200} />
            <InputLogin
                style={{ marginBottom: '16px' }}
                title='Password'
                type='password'
                onChange={(value) => onPassChange(value)}
                maxLength={50} />
            <ButtonLogin
                onClick={onClick}
                style={{
                    backgroundColor: '#309CFF',
                    color: 'white',
                    height: '40px',
                    fontSize: '18px',
                }}
                title={state === LOGIN ? "Log in" : 'Create account'} />
            {state === LOGIN ? <p>Forget your password? <span style={{
                color: '#309CFF',
                cursor: 'pointer'
            }}>Click here</span></p> : null}
        </>
    )
}
